import { useMemo } from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { is1PMacro } from '@confluence/fabric-extension-lib/entry-points/macroClassificationUtils.ts';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export const useShouldHideOverlay = (extensionKey: string, isBodiedExtension: boolean): boolean => {
	const isLivePage = useIsCurrentPageLive();

	return useMemo(() => {
		if (!extensionKey) {
			return false;
		}

		const is2PNonBodied = !is1PMacro(extensionKey) && !isBodiedExtension;
		if (is2PNonBodied || isLivePage) {
			return true;
		}

		const extensionsToHideOverlays = StatsigConfigurations.getStringList(
			'confluence_frontend_extension_overlay_removal_list',
			[],
		);

		if (extensionsToHideOverlays.length === 0) {
			return false;
		}

		if (extensionsToHideOverlays[0] === 'ALLOW_ALL') {
			return true;
		}

		const extensionKeys = extensionsToHideOverlays.map((ext) => ext.trim().toLowerCase());

		return extensionKeys.includes(extensionKey.toLowerCase());
	}, [extensionKey, isLivePage, isBodiedExtension]);
};
